module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chaptitle"
  }, [_c('a', {
    attrs: {
      "id": "first"
    }
  }), _vm._v("a first thing to remember")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("There is a Purpose inside you. There is a divine Purpose inside everyone. You knew it once. You knew it perfectly in the moment you made the decision to come here. You tucked your purpose, along with your gifts and your shadows and even your divine teacher, into your heart and promised you would never, ever forget. But then you were born, and forgetting began. But the memory slept on in your heart. And now, when you get quiet, you feel something beckoning you to a richer kind of life, a life thrumming with meaning and overflowing with joy. As you walk the spiral path ahead, you will remember the sacred purpose you carried into this world and your heart will leap in joyful recognition. But you will remember something else—something even more important: you will remember that your purpose is the Divine's Purpose expressed in and through and as the unique being that is you. It's a magnificent memory, and it is waiting for you.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68c5d282","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/08_afirstthing.vue
// module id = 81
// module chunks = 0